import clsx from 'clsx'
import DocumentAddIcon from 'modules/common/components/_icons/document-add.svg'
import PlusIcon from 'modules/common/components/_icons/plus.svg'
import {
  Button,
  ButtonProps,
} from 'modules/common/components/_ui/Button/Button'
import { DropdownMenu } from 'modules/common/components/_ui/DropdownMenu/DropdownMenu'
import { DropdownMenuItem } from 'modules/common/components/_ui/DropdownMenu/DropdownMenuItem'
import { useDropdownMenu } from 'modules/common/hooks/useDropdownMenu'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useRedirectToDocumentCreationFlow } from 'modules/invoicing/flows/document/useRedirectToDocumentCreationFlow'
import { EnumDocumentType } from 'modules/invoicing/types/document'
import React from 'react'

interface Props {
  customerId?: string
  disabled?: boolean
  variant?: ButtonProps['variant']
  className?: string
}

export const NewDocumentButton: React.FC<Props> = ({
  customerId,
  disabled = false,
  variant = 'contained',
  className,
}) => {
  const { t } = useTranslation('invoicing-components')

  const { registerDropdownButton, registerDropdownMenu } = useDropdownMenu()

  const { redirectToDocumentCreation } = useRedirectToDocumentCreationFlow()

  return (
    <>
      <Button
        variant={variant}
        color="active"
        {...registerDropdownButton()}
        className={clsx('flex flex-row items-center justify-center', className)}
        disabled={disabled}
        icon={<PlusIcon />}
        data-testid="create-document-dropdow-button"
      >
        {t('newDocumentButton.label')}
      </Button>
      <DropdownMenu {...registerDropdownMenu()}>
        <div className="flex">
          <DropdownMenuItem
            onClick={() =>
              redirectToDocumentCreation({
                documentType: EnumDocumentType.ESTIMATE,
                customerId,
              })
            }
            icon={<DocumentAddIcon className="text-primary" />}
          >
            {t('newDocumentButton.estimateCta')}
          </DropdownMenuItem>
        </div>

        <DropdownMenuItem
          onClick={() =>
            redirectToDocumentCreation({
              documentType: EnumDocumentType.INVOICE,
              customerId,
            })
          }
          icon={<DocumentAddIcon className="text-primary" />}
          data-testid="create-invoice-button"
        >
          {t('newDocumentButton.invoiceCta')}
        </DropdownMenuItem>
      </DropdownMenu>
    </>
  )
}
